import { render, staticRenderFns } from "./CBoardLeftMenu.vue?vue&type=template&id=27b533aa&scoped=true&"
import script from "./CBoardLeftMenu.vue?vue&type=script&lang=ts&"
export * from "./CBoardLeftMenu.vue?vue&type=script&lang=ts&"
import style0 from "./CBoardLeftMenu.vue?vue&type=style&index=0&id=27b533aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b533aa",
  null
  
)

export default component.exports